var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-box"},[_c('iframe',{staticClass:"frame",attrs:{"src":_vm.workflowUrlBase}}),_c('el-tooltip',{attrs:{"content":"Open in new tab","placement":"right"}},[_c('button',{staticClass:"eject-btn",on:{"click":_vm.handleEject}},[_c('i',{staticClass:"fa fa-eject"})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }